import styled from 'styled-components'

export const ScrollUpContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
`
export const Button = styled.button``
